import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./styles/theme.css";
import "./styles/login.css";
import "./styles/toast.css";
import "./styles/payment-form.css";
import "./styles/modern-receipt.css";
import "./styles/form-setup.css"
import "./styles/excel-modal.css"
import "./styles/bulk-upload.css"
import "./styles/merchant-dashboard.css"
import "./styles/form-builder.css"
import "./styles/progress-stepper.css"
import "./styles/merchant-details.css"
import "./styles/form-details.css"
import "./styles/field-editor.css"

const isPublicRoute =
  window.location.pathname.startsWith("/forms/") ||
  window.location.pathname.startsWith("/receipt/");

const root = ReactDOM.createRoot(document.getElementById("root"));
window.RETURN_URL = process.env.REACT_APP_BASE_URL_DEV

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter basename={isPublicRoute ? "/" : "/gfb-admin"}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
